// First-login continuation for businesses that bring accounting history from
// another system. The actual figures are still collected by the established
// opening-balance wizards in Settings.
function StartupProfileGate({ backend, onOpenWizard }) {
  const profile = backend?.appState?.accountingStartupProfile || null;
  const [hidden, setHidden] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const businessId = backend?.activeBusinessId || '';

  React.useEffect(() => setHidden(false), [businessId]);
  if (!profile || profile.source !== 'previous_system' || profile.promptStatus !== 'pending' || hidden) return null;

  const choose = async (transition) => {
    setBusy(true);
    try {
      await window.PlummeBackend.saveAccountingStartupProfile({ ...profile, transition, promptStatus: 'pending' });
      setHidden(true);
      onOpenWizard?.(transition === 'mid_year' ? 'startup' : 'balance');
    } catch (error) {
      toast(error?.message || t('startupGate.saveError', 'Kunne ikke lagre oppstartsvalget.'), 'error');
    } finally { setBusy(false); }
  };
  const defer = async () => {
    setBusy(true);
    try {
      await window.PlummeBackend.saveAccountingStartupProfile({ ...profile, promptStatus: 'deferred' });
      setHidden(true);
    } catch (error) {
      toast(error?.message || t('startupGate.saveError', 'Kunne ikke lagre oppstartsvalget.'), 'error');
    } finally { setBusy(false); }
  };

  return <Modal open portal center max={720} title={t('startupGate.title', 'Gjør regnskapet klart for oppstart')} onClose={() => void defer()}>
    <p>{t('startupGate.help', 'Du har valgt at foretaket kommer fra et annet system. Velg hvordan tallene skal videreføres. Veiviseren kan også åpnes senere fra Innstillinger.')}</p>
    <div className="col gap-12" style={{ marginTop: 18 }}>
      <Button icon="pencil" disabled={busy} onClick={() => void choose('year_start')}>{t('startupGate.openingBalance', 'Legg inn inngående balanse')}</Button>
      <Button variant="secondary" icon="pencil" disabled={busy} onClick={() => void choose('mid_year')}>{t('startupGate.midYear', 'Legg inn oppstartstall midt i året')}</Button>
      <Button variant="ghost" disabled={busy} onClick={() => void defer()}>{t('startupGate.later', 'Gjør det senere')}</Button>
    </div>
  </Modal>;
}
window.StartupProfileGate = StartupProfileGate;
